"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var removeUndefined_1 = __importDefault(require("common/utils/removeUndefined"));
var moment_1 = __importDefault(require("moment"));
var warehouseItemsSlice_1 = require("src/features/warehouseItems/warehouseItemsSlice");
var warehouseTransferOperationsSlice_1 = require("src/features/warehouseTransferOperations/warehouseTransferOperationsSlice");
function ConfirmSendTransfer(dispatch, userId, warehouseId, warehouseItems, warehouseTransferOperation, warehouseTransferOperationId) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var sameProducts, _d, quantity, serialNumbers, assetsNumbers, stockNumber, stockRequestNumber, sameProductQuantity, restQuantity, newQuantity;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    sameProducts = warehouseItems.find(function (x) {
                        return x.productId === warehouseTransferOperation.productId &&
                            x.stockNumber === warehouseTransferOperation.stockNumber &&
                            x.projectId === warehouseTransferOperation.projectId;
                    });
                    _d = warehouseTransferOperation !== null && warehouseTransferOperation !== void 0 ? warehouseTransferOperation : {}, quantity = _d.quantity, serialNumbers = _d.serialNumbers, assetsNumbers = _d.assetsNumbers, stockNumber = _d.stockNumber, stockRequestNumber = _d.stockRequestNumber;
                    sameProductQuantity = (_a = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.quantity) !== null && _a !== void 0 ? _a : 0;
                    restQuantity = sameProductQuantity - quantity;
                    if (!(restQuantity < 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch((0, warehouseTransferOperationsSlice_1.editTransferOperation)({
                            id: warehouseTransferOperationId,
                            status: "rejected",
                        }))];
                case 1:
                    _e.sent();
                    antd_1.message.error("This Operation been Rejected because of no enough quantity!");
                    return [2 /*return*/, "error"];
                case 2:
                    newQuantity = sameProductQuantity - quantity;
                    return [4 /*yield*/, dispatch((0, warehouseItemsSlice_1.editWarehouseItem)({
                            id: sameProducts.id,
                            quantity: newQuantity,
                            serialNumbers: (sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.serialNumbers)
                                ? (_b = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.serialNumbers) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return !serialNumbers.includes(x); })
                                : [],
                            assetsNumbers: (sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.assetsNumbers)
                                ? (_c = sameProducts === null || sameProducts === void 0 ? void 0 : sameProducts.assetsNumbers) === null || _c === void 0 ? void 0 : _c.filter(function (x) { return !assetsNumbers.includes(x); })
                                : [],
                        }))];
                case 3:
                    _e.sent();
                    return [4 /*yield*/, dispatch((0, warehouseTransferOperationsSlice_1.editTransferOperation)(__assign({ id: warehouseTransferOperationId }, (0, removeUndefined_1.default)({
                            destinationStockNumber: stockNumber,
                            // notes: values.notes ?? '',
                            updatedAt: (0, moment_1.default)(),
                            status: "sent",
                            receivedAt: (0, moment_1.default)(),
                            receivedBy: userId,
                            senderAfter: sameProductQuantity - quantity,
                            stockRequestNumber: stockRequestNumber,
                        }))))];
                case 4:
                    _e.sent();
                    antd_1.message.success("success");
                    return [2 /*return*/, "done"];
            }
        });
    });
}
exports.default = ConfirmSendTransfer;
